import { configureStore } from '@reduxjs/toolkit';
import commonRedcucers from './slices/common-slice';
export default configureStore({
  reducer: commonRedcucers
});
